import * as React from 'react';
import styled from 'styled-components'
import badge from '../assets/images/badge.svg'
import normalBadge from '../assets/images/badge-normal1.svg';
import notEarnedBadge from '../assets/images/badge-not-earned.svg';

// import { Badge } from '@material-ui/core';

import {iconUrl } from "./services";
const DivContainer = styled.div`
        background-color: #1a1a1a;
        border-radius: 2px;

        & .call-to-upgrade {
            font-family: "Roboto", sans-serif;
            font-size: 15px;
            font-style: italic;
            color: #c6c6c6;
            padding-left: 2em;
            padding-top: 2em;
        }
        & .call-to-upgrade span {
            color: #3ee9f7;
            font-family: "Roboto Condensed", sans-serif;
            font-weight: bold;
        }
    `
    const BadgesContainer = styled.div`
        
        width: 100%;
        display: grid;
        grid-template-columns: repeat(10, minmax(80px, 200px));
        grid-auto-rows: minmax(100px, 200px);
        padding: 0 1.5em 1.5em 1.5em;
        // margin: 10em 0;
        

        @media all and (max-width: 1600px) {
            grid-template-columns: repeat(8, minmax(80px, auto));
        }
        @media all and (max-width: 1600px) {
            grid-template-columns: repeat(7, minmax(80px, 200px));
        }
        @media all and (max-width: 1200px) {
            grid-template-columns: repeat(6, minmax(80px, 160px));
        }
        @media all and (max-width: 960px) {
            grid-template-columns: repeat(5, minmax(80px, 160px));
        }
        @media all and (max-width: 640px) {
            grid-template-columns: repeat(4, minmax(80px, 160px));
        }
        
    `

    const BadgeEntry = styled.div`
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        & img {
            width: 64px;
        }
  
        & .badge-description {
            color: white;
            font-family: 'Roboto Condensed', sans-serif;
            font-size: 12px;
            text-transform: uppercase;
            text-align: center;            
        }

        & .badge-not-earned {
            color: #555555;

        }
    `
const badgesDisplay = props => {
    const onBadgeClick = (id) => {
        props.onBadgeClick(id);
    }
    
    if (props.badges){
        return (
            <DivContainer>
                {props.userUpgraded === 0 ? <p className="call-to-upgrade"><span onClick={props.onClickUpgrade}>UPGRADE</span> to earn more badges!</p>:  ''}
                <BadgesContainer>
                    {props.badges.map((d, idx) => <BadgeEntry 
                        key={d[props.idkey]}                        
                        value={d.id}
                        // tslint:disable-next-line jsx-no-lambda
                        onClick = {() => onBadgeClick(d.id)}
                        >
                        <img src={d[props.earnedkey] ? normalBadge : notEarnedBadge} />
                        <p className={d[props.earnedkey] ? "badge-description" : "badge-description badge-not-earned"}>{d[props.namekey]}</p></BadgeEntry>)}                    

                </BadgesContainer>
            </DivContainer>
        )
    }
    else{
        return(
            <p style={{paddingTop: "2em"}}>No badges Yet</p>
        );
    }
    
}

export default badgesDisplay;


// WEBPACK FOOTER //
// ./src/common/badgesDisplay.Component.tsx